import React from "react";
import translate from "components/translations/translations.wrapper";


export const NotificationsContent = ({...props}: any): React.ReactElement => {


    return (
      <span> Form content here...</span>
    )
}

const withTranslations = translate(NotificationsContent);
export default withTranslations;